module.exports = __webpack_public_path__ + "img/banner7.e0920d8a.jpg";